import React from 'react';
import {makeStyles} from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import { Typography } from '@material-ui/core';

import PBDQProfilesTab from './components/DQInsiderProfilesTab.comp';

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(4),
        marginBottom: theme.spacing(3),
        display: 'flex',
        flexDirection: 'column',
    },
}));

// Standalone page for the PBDQS List (was a tab on the Licenses & Billing page;
// same component, no behaviour change).
function PBDQList_ORG() {
    const classes = useStyles();

    return (
        <Container component="main" maxWidth='false'>
            <div className={classes.paper}>
                <Typography variant="h5" style={{ fontWeight: 600, margin: 0 }}>
                    PBDQS List
                </Typography>
            </div>
            <div style={{ width: '100%' }}>
                <PBDQProfilesTab />
            </div>
        </Container>
    );
}

export default PBDQList_ORG;
